
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import invoiceModal from './components/invoicemodal.vue';
import lazyInject from '@/di';
import InvoiceService from '@/services/invoice.service';
import SPUService from '@/services/spu.service';
import moment from 'moment';
import LookCOeder from './components/lookCOeder.vue';
import AgainInvoice from './components/againInvocie.vue';

@Component({
  components: {
    invoiceModal,
    'look-coeder': LookCOeder,
    'again-invoice': AgainInvoice,
  },
})
export default class InvoiceManagement extends Vue {
  @Ref('invoiceModal')
  invoiceModal!: invoiceModal;

  @Ref('againInvoice')
  againInvoice!: AgainInvoice;

  @Ref('lookCOeder')
  lookCOeder!: LookCOeder;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  statusList = [
    { key: '开票中', val: 1 },
    { key: '已开票', val: 2 },
    { key: '审核不通过', val: 3 },
    { key: '已驳回', val: 4 },
  ];

  data: any[] = [];
  form: any = {
    ka_id: '',
    verify_time: [],
    status: undefined,
  };

  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    onChange: this.paginationChange,
  };

  kaList: any[] = [];

  verify_time = [];

  invoiceDate: any[] = [];

  applyTime: any[] = [];

  columns = [
    {
      title: '发票分类',
      dataIndex: 'invoice_category',
      align: 'center',
      width: 180,
    },
    {
      title: '抬头类型',
      dataIndex: 'buyer_category',
      align: 'center',
      width: 120,
    },
    {
      title: '发票抬头',
      dataIndex: 'buyer_title',
      align: 'center',
      width: 180,
      scopedSlots: { customRender: 'buyer_title' },

    },
    {
      title: '企业税号',
      dataIndex: 'buyer_tax_no',
      align: 'center',
      width: 180,
      scopedSlots: { customRender: 'buyer_tax_no' },
    },
    {
      title: '开户行',
      dataIndex: 'buyer_bank_name',
      align: 'center',
      width: 180,
      scopedSlots: { customRender: 'buyer_bank_name' },
    },
    {
      title: '发票金额',
      dataIndex: 'credit',
      align: 'center',
      width: 120,
    },
    {
      title: '发票商品名称',
      dataIndex: 'goods_name',
      align: 'center',
      width: 180,
    },
    {
      title: '申请时间',
      dataIndex: 'apply_time',
      align: 'center',
      width: 120,
    },
    {
      title: '开票时间',
      dataIndex: 'invoice_date',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        if (text === '0000-00-00') {
          return '--';
        }
        return text;
      },
    },
    {
      title: '发票开具方',
      dataIndex: 'invoice_from',
      align: 'center',
      width: 180,
      customRender: (text: any) => {
        let _text: any = '高德';
        if (text === '1') {
          _text = '高德';
        } else if (text === '2') {
          _text = '大有';
        }
        return _text;
      },
    },
    {
      title: '状态',
      dataIndex: 'status_str',
      align: 'center',
      width: 120,
    },
    {
      title: '驳回原因',
      dataIndex: 'remark',
      align: 'center',
      width: 180,
      customRender: (text: any) => {
        if (!text) {
          return '--';
        }
        return text;
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 160,
    },
  ];
  selectedRowKeys: any[] = [];
  @Watch('$route')
  onRouteChange() {
    const { ka_id, invoice_date_start, invoice_date_end, status, page, pageSize, apply_time_start, apply_time_end } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (ka_id) {
      query.ka_id = ka_id;
      this.form.ka_id = +ka_id;
    } else {
      query.ka_id = this.kaList[0].val;
      this.form.ka_id = this.kaList[0].val;
    }
    if (invoice_date_start && invoice_date_end) {
      query.invoice_date_start = invoice_date_start;
      query.invoice_date_end = invoice_date_end;
      this.invoiceDate = [moment(invoice_date_start as string), moment(invoice_date_end as string)];
    }
    if (apply_time_start && apply_time_end) {
      query.apply_time_start = apply_time_start;
      query.apply_time_end = apply_time_end;
      this.applyTime = [moment(apply_time_start as string), moment(apply_time_end as string)];
    }
    if (status) {
      query.status = status;
      this.form.status = +status;
    }
    this.getInvoiceList(query);
  }

  refresh() {
    this.invoiceDate = [];
    this.form.invoice_date_start = '';
    this.form.invoice_date_end = '';
    this.form.ka_id = this.kaList[0].val;
    this.form.status = undefined;
    this.pagination.current = 1;
    const query: any = {};
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const { ka_id, invoice_date_start, invoice_date_end, status, apply_time_start, apply_time_end } = this.form;
    const query: any = {
      page,
      pageSize,
    };
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (invoice_date_start && invoice_date_end) {
      query.invoice_date_start = invoice_date_start;
      query.invoice_date_end = invoice_date_end;
    }
    if (apply_time_start && apply_time_end) {
      query.apply_time_start = apply_time_start;
      query.apply_time_end = apply_time_end;
    }
    if (status) {
      query.status = status;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  search() {
    const { ka_id, invoice_date_start, invoice_date_end, status, apply_time_start, apply_time_end } = this.form;
    const query: any = {};
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (invoice_date_start && invoice_date_end) {
      query.invoice_date_start = invoice_date_start;
      query.invoice_date_end = invoice_date_end;
    }
    if (apply_time_start && apply_time_end) {
      query.apply_time_start = apply_time_start;
      query.apply_time_end = apply_time_end;
    }
    if (status) {
      query.status = status;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  onSelectChange(selectedRowKeys: any[]) {
    this.selectedRowKeys = selectedRowKeys;
  }
  handRecord: any = {};
  handleEdit(record: any) {
    this.handRecord = record;
  }


  handleInvoice(record: any) {
    this.againInvoice.init(record);
  }

  handleChange(val: any) {
    this.invoiceDate = val;
    if (val && val.length) {
      this.form.invoice_date_start = moment(val[0]).format('YYYY-MM-DD');
      this.form.invoice_date_end = moment(val[1]).format('YYYY-MM-DD');
    } else {
      this.form.invoice_date_start = '';
      this.form.invoice_date_end = '';
    }
  }


  handleChangeApplyTime(val: any) {
    this.applyTime = val;
    if (val && val.length) {
      this.form.apply_time_start = moment(val[0]).format('YYYY-MM-DD');
      this.form.apply_time_end = moment(val[1]).format('YYYY-MM-DD');
    } else {
      this.form.apply_time_start = '';
      this.form.apply_time_end = '';
    }
  }

  handleDelete(record: any) {
    this.lookCOeder.init(record);
  }
  async getInvoiceList(shopData: any) {
    const res = await this.invoiceService.getInvoiceRecord(shopData);
    this.data = res.list;
    this.pagination.total = res.total;
  }

  mounted() {
    this.getKaList();
  }

  async getKaList() {
    const res = await this.spuService.kaSpuAccessibleKas();
    if (res && res.length) {
      this.kaList = [...res];
    }
    this.onRouteChange();
  }
}
